import { render, staticRenderFns } from "./WebPartFormLinkDesigner.vue?vue&type=template&id=35c15283&"
import script from "./WebPartFormLinkDesigner.vue?vue&type=script&lang=js&"
export * from "./WebPartFormLinkDesigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports